import {
  createPlaybookMentionMarkdown,
  createPlaybookRuleMentionMarkdown,
} from 'src/components/ai/chat/ChatPanel/ChatEditor/ChatEditorMention/document-mention-markdown';

/**
 * What the header's sparkle puts in the chat input: the playbook as a mention
 * chip, then an open-ended request the user finishes. The edits slot is a bold
 * bracketed placeholder, the same convention as the generate and run prompts
 * and the official prompts, so the user can see what to replace before sending.
 */
export function createEditPlaybookPrompt({
  playbookId,
  playbookTitle,
}: {
  playbookId: string;
  playbookTitle: string;
}): string {
  const mention = createPlaybookMentionMarkdown({
    displayText: playbookTitle,
    playbookId,
  });
  return `Make the following edits to this playbook ${mention}: **[describe the edits here]**`;
}

/**
 * The rule panel's sparkle: the same request, scoped to one rule. The rule
 * is a mention chip of its own, like a task inside a workflow: the server
 * resolves and verifies its playbook from the rule id, so the playbook is
 * not mentioned separately.
 */
export function createEditRulePrompt({
  ruleId,
  ruleTitle,
}: {
  ruleId: string;
  ruleTitle: string;
}): string {
  const mention = createPlaybookRuleMentionMarkdown({
    displayText: ruleTitle,
    playbookRuleId: ruleId,
  });
  return `Make the following edits to this rule ${mention}: **[describe the edits here]**`;
}
